// extracted by mini-css-extract-plugin
export default {"salary-info-no-wrap":"F9LBfu2___salary-info-no-wrap","salaryInfoNoWrap":"F9LBfu2___salary-info-no-wrap"};